/** `seen_guides` on `users/me` and `users/update_me`. Missing or non-list values are an empty list. */

export const parseSeenGuides = (raw: unknown): string[] => {
  if (!Array.isArray(raw)) {
    return [];
  }

  return raw.filter((item): item is string => typeof item === 'string');
};

export const appendSeenGuide = (current: readonly string[] | undefined, guideId: string): string[] => {
  const guides = current ?? [];

  if (guides.includes(guideId)) {
    return [...guides];
  }

  return [...guides, guideId];
};
